<template>
  <div class="about-video section-gap">
    <div class="container">
      <div class="row">
        <div class="container text-center splash-s splash-container d-flex">
          <h1 class="white h1-larger">THROWBACK 2019</h1>
        </div>
      </div>
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-lg-7 mt-5">
          <div class="container">
            <div class="card border-0 shadow-md text-white border-rad">
              <img
                id="image"
                class="border-rad img-fluid"
                src="static/img/VideoThumbnail.jpg"
                alt="Card image"
                width="1170"
                height="400"
              />
              <div class="card-img-overlay black-tp-layer pos-center text-center border-rad">
                <div class="center-holder">
                  <a data-fancybox="video" href="https://www.youtube-nocookie.com/embed/c3ETybD7Enk?autoplay=1" class="play-button">
                    <i>
                      <span class="btn-text">
                        <span>Play</span>
                      </span>
                      <span class="btn-icon">
                        <i class="fa fa-play"></i>
                      </span>
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 mt-5">
          <div id="wrap-color" class="section-title-wrapper container">
            <h2>{{this.review.title}}</h2>
            <div class="row">
              <div id="text">
                <p class="mb-0 lead p-larger">{{this.review.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import client from "../../utils/api.js";
export default {
  data() {
    return {
      review: {
        title: "",
        description: "",
        url: ""
      }
    };
  },
  created() {
    //Get Grundinfo
    client
      .getEntries({ content_type: "review", order: "-sys.createdAt" })
      .then(response => {
        this.review.title = response.items[0].fields.title;
        this.review.description = response.items[0].fields.beschreibung;
        this.review.url = response.items[0].fields.url;
      });
  }
};
</script>
<style scoped>
.container-fluid {
  width: 80% !important;
}

.section-title-wrapper {
  margin-bottom: 0 !important;
}

h1 {
  color: white !important;
}
#image {
  border-radius: 0;
}
#wrap-color > h2,
p {
  color: white !important;
}
#text {
  padding-left: 15px;
}

 .h1-larger {
    font-size: 4.5em;
  }

.splash-s {
  background-image: url(/static/img/splash2.png);
  background-position: 20% 30%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 200px;
}
.splash-container {
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 760px) {
   .h1-larger {
    font-size: 3em;
  }
  .splash-s {
    background-image: url(/static/img/splash2.png);
    background-position: 5% 20%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
}

@media screen and (min-width: 761px) and (max-width: 1000px) {
   .h1-larger {
    font-size: 3em;
  }
  .splash-s {
    background-image: url(/static/img/splash2.png);
    background-position: 18% 40%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .h1-larger {
    font-size: 4.5em !important;
  }
  .p-larger {
    font-size: 1.9em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash2.png);
    background-position: 5% 40%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
}

</style>
